import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const FileTypeEmptyState = {
  fileTypes: [],
  selectedFileType: null,
};

export const FileTypeKey = 'fileTypes';

export const fileTypesSlice = createSlice({
  name: 'fileTypes',
  initialState: getLocalStorage(LocalStorageTypes.FILETYPES)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.FILETYPES))
    : FileTypeEmptyState,
  reducers: {
    setFileTypes: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.FILETYPES, result);
      return { ...state, ...action.payload };
    },
    updateSelectedFileType: (state, action) => {
      const result = { ...state, selectedFileType: action.payload };
      persistLocalStorage(FileTypeKey, result);
      return result;
    },
    resetFileTypes: () => {
      clearLocalStorage('fileTypes');
      return FileTypeEmptyState;
    },
  },
});

export const { setFileTypes, updateSelectedFileType, resetFileTypes } =
  fileTypesSlice.actions;
